module.exports = __webpack_public_path__ + "static/img/视频.cebf42a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/documentPic/视频.png
// module id = 1025
// module chunks = 1